function DazContract1155XC(address, cfg, proxyAddress = null) {
    address = dazethutil.toLower(address);
    this.config = cfg || {};
    this.address = address;
    this.proxyAddress = proxyAddress;
    const ct = this.config.contracts.list[address];
    this.names = ct.name;
    this.tokens = ct.tokens;
}

DazContract1155XC.prototype.getName = function (token) {
    return this.tokens[token].name;
}

DazContract1155XC.prototype.getImageURL = function (token) {
    return this.tokens[token].image;
}

DazContract1155XC.prototype.getThumbURL = function (token) {
    return this.tokens[token].thumb;
}

DazContract1155XC.prototype.getMetadataURL = async function (token) {
}

DazContract1155XC.prototype.balanceOf = async function (address, token) {
    return this.load(address).then(cd => {
        return cd.BalanceOf;
    });
}

DazContract1155XC.prototype.load = async function (address) {
    if (!window.dazXC) {
        throw 'Not cross chain c1155';
    }
    return { BalanceOf: 0 }
}
